import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => {
  return {
    listItem: {
      padding: `${token.paddingLG}px !important`
    },

    card: {}
  }
})
